





























































import Vue from 'vue';
import store from '@/store';
import { WorkflowStep } from '@/store/getStarted';

import GetStartedNav from '@/components/getStarted/GetStartedNav.vue';

export default Vue.extend({
  components: {
    GetStartedNav
  },

  methods: {
    syncWithGoogleClassroom() {
      store.dispatch.getStarted.getGoogleClassrooms();
    },

    manuallyBuildGroup() {
      store.dispatch.getStarted.startManualGroupBuild();
      store.dispatch.getStarted.goToStep(WorkflowStep.BUILD_GROUP);
    }
  }
});
